module.exports = __webpack_public_path__ + "img/ctrl-a-stub-up--.7cb6fc49.svg";